export const selectKambiWidget = state => state.kambiWidget;
export const selectBetslip = state => state.kambiWidget.outcomes;
export const selectIsOutcomeInBetSlip = (state, props) => state.kambiWidget.outcomes.some(outcome => outcome.id === props.outcomeId);
